<template>
  <span class="dialog-footer">
    <span class="dialog-footer-illustrate">
      <span class="dialog-footer-illustrate-icon">*</span>
      <span class="dialog-footer-illustrate-text"
        >不足天数的账期自动结算金额（可手动编辑修改）</span
      >
    </span>
    <span class="dialog-footer-btns">
      <el-button class="cancel" @click="close">取 消</el-button>
      <el-button class="save" type="primary" @click="saveRentOrder">
        确 定
      </el-button>
    </span>
  </span>
</template>

<script>
export default {
  name: 'PreviewRentOrderFooter',
  props: {
    payMode: {
      type: [String, Number],
      default: '',
    },
    planAmount: {
      type: [String, Number],
      default: '',
    },
    fundType: {
      type: [String, Number],
      default: '',
    },
    tableDataFrom: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  methods: {
    // 关闭弹框
    close() {
      this.$emit('close')
    },
    // 保存预览订单
    saveRentOrder() {
      const {
        fundType,
        planAmount,
        payMode,
        tableDataFrom: { tableData },
      } = this
      const row = {
        fundType,
        planAmount,
        payMode,
        items: tableData.map((item) => ({
          num: item.num,
          planAmount: item.planAmount,
          dueDate: item.dueDate,
          remarks: item.remarks,
          startCycleDate: item.accruedCycle[0],
          endCycleDate: item.accruedCycle[1],
        })),
      }
      this.$emit('confirmBill', row)
    },
  },
}
</script>

<style lang="scss" scoped>
.dialog-footer {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: space-between;
  &-illustrate {
    color: #969799;
    margin-left: 27px;
    position: relative;
    &-icon {
      display: inline-block;
      width: 7px;
      color: #fa5151;
      font-size: 16px;
      position: absolute;
      top: 50%;
      transform: translateY(-8px);
    }
    &-text {
      margin-left: 11px;
    }
  }
  &-btns {
    display: flex;
    .cancel,
    .save {
      width: 76px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 2px;
      font-size: 14px;
    }
    .cancel {
      border: 1px solid #dcdee0;
      color: #323233;
    }
    .save {
      background-color: #2e7eff;
    }
  }
}
</style>
